// The canonical Workout Preferences defaults (§17.2), mirrored from the
// backend's createDefaultWorkoutPreferences. Every frontend consumer (Settings,
// the execution rest integration, Keep Screen Awake) resolves defaults here.
export const REST_TIMER_MODES = Object.freeze(["AUTOMATIC", "MANUAL", "OFF"]);

export const WORKOUT_PREFERENCE_DEFAULTS = Object.freeze({
  weightUnit: null,
  weightUnitUpdatedAt: null,
  restTimerMode: "AUTOMATIC",
  defaultRestSeconds: 120,
  keepScreenAwake: true,
  previousPerformanceDefault: true,
  olympicBarbellConvention: null,
  olympicBarWeightValue: null,
  olympicBarWeightUnit: null,
});

// Fills only what is unavailable: no preferences at all, a missing value, or an
// unknown rest mode / non-boolean toggle. Nullable first-use answers
// (weightUnit, olympicBarbellConvention) stay null so first-use still asks. A
// present but unusable defaultRestSeconds is left as data for the rest domain
// (§14.5 normalization), never silently replaced here.
export function resolveWorkoutPreferences(preferences) {
  const source = preferences || {};
  return {
    ...WORKOUT_PREFERENCE_DEFAULTS,
    ...source,
    restTimerMode: REST_TIMER_MODES.includes(source.restTimerMode)
      ? source.restTimerMode
      : WORKOUT_PREFERENCE_DEFAULTS.restTimerMode,
    defaultRestSeconds: source.defaultRestSeconds ?? WORKOUT_PREFERENCE_DEFAULTS.defaultRestSeconds,
    keepScreenAwake: typeof source.keepScreenAwake === "boolean"
      ? source.keepScreenAwake
      : WORKOUT_PREFERENCE_DEFAULTS.keepScreenAwake,
    previousPerformanceDefault: typeof source.previousPerformanceDefault === "boolean"
      ? source.previousPerformanceDefault
      : WORKOUT_PREFERENCE_DEFAULTS.previousPerformanceDefault,
  };
}

// Previous performance is one global setting (§13.10): the open workout reads
// the live preference, with no Start snapshot and no local override. A missing
// or non-boolean value reads ON.
export function previousPerformanceEnabled(preferences) {
  return resolveWorkoutPreferences(preferences).previousPerformanceDefault;
}
